export default __webpack_public_path__ + "static/media/logo-w.c7745af6.png";